import IgnoreLists from "../../../components/ignore-list/ignore-list";
import Page from "../../page";

const IgnoreListPage = () => {
  return (
    <Page>
      <IgnoreLists />
    </Page>
  );
};

export default IgnoreListPage;
